import { AnswserQuestion } from "./questions.model";

export interface Settings {
  dustLevel: number;
  siteLevel: number;
  minimumRenewalRate: number;
  renewalRate: number;
  minimalDepressionValue: number;
  depressionValuetoMaintain: number;
  leakRate: number;
  isLeakRatePrecise: boolean;
  typeOfContainement: TypeOfContainement;
  estimedLeakRate: number;
  answers: AnswserQuestion[];
}

export enum TypeOfContainement {
  TypeI = "Type I",
  TypeII = "Type II",
  TypeIII = "Type III",
  TYPEIV = "Type IV",
}

export enum DustLevel {
  Level1 = 3300,
  Level2 = 6000,
  Level3 = 10000,
  Level4 = 25000,
}
